/*!
 * Copyright 2021 Cognite AS
 */

export enum RenderMode {
  Color = 1,
  Normal,
  TreeIndex,
  PackColorAndNormal,
  Depth,
  Effects,
  Ghost,
  LOD,
  DepthBufferOnly,
  GeometryType
}
